import React, { Component, Fragment } from 'react'
import { BrowserRouter } from 'react-router-dom'
import { ThemeProvider } from 'styled-components'

import 'react-dates/initialize'

import PrimaryLayout from 'Layouts/PrimaryLayout'

import ThemeContext, { ThemeConsumer } from 'Services/ThemeContext'
import GlobalStyle from 'Styles/GlobalStyle'
import * as themes from 'Styles/Themes'

class App extends Component {
  render () {
    return (
      <ThemeContext>
        <BrowserRouter>
          <ThemeConsumer>
            {
              ({ theme }) => (
                <ThemeProvider theme={themes[theme]}>
                  <Fragment>
                    <PrimaryLayout />
                    <GlobalStyle />
                  </Fragment>
                </ThemeProvider>
              )
            }
          </ThemeConsumer>
        </BrowserRouter>
      </ThemeContext>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/App.js